/**
 * Join an array of selectors into a single selector.
 */
export const join = (selectors: string[], separator: string = ';'): string =>
  selectors.join(separator);
